import { jsx } from "react/jsx-runtime";
import * as prismicR from "@prismicio/richtext";
import { PrismicRichText as PrismicRichText$1 } from "./react-server/PrismicRichText.js";
import { usePrismicContext } from "./usePrismicContext.js";

const PrismicRichText = function PrismicRichText2(_ref) {
  let {
    components,
    ...restProps
  } = _ref;
  const context = usePrismicContext();
  const serializer = prismicR.composeSerializers(typeof components === "object" ? prismicR.wrapMapSerializer(components) : components, typeof context.richTextComponents === "object" ? prismicR.wrapMapSerializer(context.richTextComponents) : context.richTextComponents);
  return /* @__PURE__ */jsx(PrismicRichText$1, {
    components: serializer,
    internalLinkComponent: context.internalLinkComponent,
    externalLinkComponent: context.externalLinkComponent,
    ...restProps
  });
};

export { PrismicRichText };